import { ReactNode } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

interface DialogProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const Dialog = ({ isOpen, children, onClose }: DialogProps) => {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={onClose}
          />

          {/* Content */}
          <div className="relative bg-white rounded-lg max-h-[90vh] overflow-auto">
            <button
              onClick={onClose}
              className="text-gray-400 absolute right-4 top-4 hover:text-gray-500 focus:outline-none align-self-right"
              aria-label="Close dialog"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
            {children}
          </div>
        </div>
      )}
    </>
  );
};
export default Dialog;
